module.exports = __webpack_public_path__ + "static/media/students-in-uniform.aceb0d21.jpg";